import { Component, OnInit } from '@angular/core';
import { AuthService } from '@core/services/core/auth/auth.service';
import { MMobileHelperService } from '@core/services/core/mmobile-helper.service';

@Component({
  selector: 'app-rgpdue-policy-info-detail',
  templateUrl: './rgpdue-policy-info-detail.component.html',
  styleUrls: ['./rgpdue-policy-info-detail.component.scss']
})
export class RgpduePolicyInfoDetailComponent implements OnInit {
  policy: any;

  constructor(
    public auth: AuthService,
    private mmobile: MMobileHelperService
  ) {}

  ngOnInit() {
    this.policy = this.mmobile.getCustomConfigData().policyGeneric.URL;
  }
}
